import type { IconButtonProps } from '@mui/material';
import { InfoIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';

const LegendIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.legend', 'Legend');

    return (
      <IconButton ref={ref} {...props} tooltipTitle={tooltipTitle}>
        <InfoIcon />
      </IconButton>
    );
  },
);

LegendIconButton.displayName = 'LegendIconButton';
export default LegendIconButton;
